const PAYMENT_METHODS = {
  INVOICE: 'Invoice',
  CREDIT_CARD: 'Credit card',
};

export const getPaymentMethods = (invoiceSummaries) => {
  const paymentMethods = invoiceSummaries.reduce((acc, invoiceSummary) => acc.concat(invoiceSummary.paymentMethods.map(paymentMethod => (PAYMENT_METHODS[paymentMethod]))), []);
  const uniquePaymentMethods = [...new Set(paymentMethods)];
  return uniquePaymentMethods;
};

export default getPaymentMethods;
